(function Module() {
	'use strict';

mySynch.directive('directiveInjector', [function () {
    return {
                restrict: 'A',
                scope: {
                    directiveHtmlString: '@'
                },
                link: function (scope, element, attrs) {
                    var  breakpoint = "";
                     scope.appendCompiledDirective(element,scope.directiveHtmlString);
                },controller: ["$scope","$compile","$element",
                    function($scope,$compile,$element) {
                    
                       $scope.appendCompiledDirective = function appendCompiledDirective(el,directiveHtmlString){
                          el.append($compile(directiveHtmlString)($scope));
                       }; 
                       
                        
                    }
                ]
            };

}]);

})();